export default "__VITE_ASSET__C5p00y$O__"